import { useEffect, useState } from "react";
import { questionService } from "../../services/api";

const LABELS = {
  ready: "Ready",
  building: "Still building",
  failed: "Broken",
  not_configured: "Uploaded, but grading is off",
};
const FINAL = new Set(["ready", "failed", "not_configured"]);

// Tells the instructor whether a freshly uploaded set can be graded yet.
// SQL sets answer immediately; Python sets build for a minute or two, so keep
// checking, and stop after maxChecks so a stuck build doesn't look like progress.
export default function AutograderStatus({ uploadId, pollMs = 10000, maxChecks = 30 }) {
  const [result, setResult] = useState(null);
  const [problem, setProblem] = useState(null);

  useEffect(() => {
    if (!uploadId) return undefined;
    let cancelled = false;
    let timer;
    let checks = 0;

    const check = async () => {
      checks += 1;
      try {
        const status = await questionService.getAutograderStatus(uploadId);
        if (cancelled) return;
        setResult(status);
        setProblem(null);
        if (FINAL.has(status.status)) return;
        if (checks >= maxChecks) {
          setProblem("It has been building for much longer than usual. Something may be wrong; contact the BrainBoost team.");
          return;
        }
        timer = setTimeout(check, pollMs);
      } catch (error) {
        if (!cancelled) setProblem("Could not check the grading status. Reopen this page to try again.");
      }
    };

    check();
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [uploadId, pollMs, maxChecks]);

  if (!uploadId) return null;

  const kind = result?.status || "checking";
  return (
    <div className={`manage-questions-autograder-status manage-questions-autograder-status--${kind}`} role="status">
      <strong>Grading status: {LABELS[kind] || (result ? kind : "Checking…")}</strong>
      {result?.message && <span> {result.message}</span>}
      {problem && <div>{problem}</div>}
    </div>
  );
}
